/**
 * Signup — disabled. Accounts are provisioned by administrators via
 * the set_user_claims.py script. This page immediately redirects to /login.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
const Signup: React.FC = () => {
  const navigate = useNavigate();
  React.useEffect(() => {
    navigate('/login', { replace: true });
  }, [navigate]);
  return null;
};
export default Signup;
